import {
  WorkflowTruckI,
  WorkflowTruckActionI,
  WorkflowTruckRequiredI,
} from "../../../libs/interfaces";
import { StateCreator } from "zustand";
import { handleWatermark } from "../../../libs/helpers";

export const createWorkflowTruckSlice: StateCreator<
  WorkflowTruckI & WorkflowTruckActionI,
  [],
  []
> = (set, get) => ({
  id: null,
  container: "",
  client: "",
  clientId: null,
  producer: "",
  producerId: null,
  farm: "",
  farmId: null,
  producerShort: "",
  farmShort: "",
  magap: "",
  zone: "",
  balerCode: "",
  brand: "",
  brandId: null,
  box: "",
  boxId: null,
  ciConductor: "",
  placa: "",
  calidad: "",
  calidadCi: "",
  gancho: "",
  ganchoCi: "",
  driver: "",
  companyTransport: "",
  observation: "",
  numCajas: null,
  cajasEstiba: null,

  startProcess: "",
  closeProcess: "",
  endLoading: "",
  containerClose: "",
  containerOulet: "",

  photo1: "",
  photo2: "",
  photo3: "",
  photo4: "",
  photo5: "",
  photo6: "",
  photo7: "",
  photo8: "",

  statusT: 0,

  setContainer: (container) => set(() => ({ container })),
  setClient: (client) => set(() => ({ client })),
  setClientId: (clientId) => set(() => ({ clientId })),
  setProducer: (producer) => set(() => ({ producer })),
  setProducerId: (producerId) => set(() => ({ producerId })),
  setFarm: (farm) => set(() => ({ farm })),
  setFarmId: (farmId) => set(() => ({ farmId })),
  setProducerShort: (producerShort) => set(() => ({ producerShort })),
  setFarmShort: (farmShort) => set(() => ({ farmShort })),
  setZone: (zone) => set(() => ({ zone })),
  setBalerCode: (balerCode) => set(() => ({ balerCode })),
  setBox: (box) => set(() => ({ box })),
  setBoxId: (boxId) => set(() => ({ boxId })),
  setBrand: (brand) => set(() => ({ brand })),
  setBrandId: (brandId) => set(() => ({ brandId })),
  setMagap: (magap) => set(() => ({ magap })),
  setId: (id) => set(() => ({ id })),
  setCiConductor: (ciConductor) => set(() => ({ ciConductor })),
  setPlaca: (placa) => set(() => ({ placa })),
  setCalidad: (calidad) => set(() => ({ calidad })),
  setCalidadCi: (calidadCi) => set(() => ({ calidadCi })),
  setGancho: (gancho) => set(() => ({ gancho })),
  setGanchoCi: (ganchoCi) => set(() => ({ ganchoCi })),
  setDriver: (driver) => set(() => ({ driver })),
  setCompanyTransport(companyTransport) {
    set(() => ({ companyTransport }));
  },
  setObservation: (observation) => set(() => ({ observation })),
  setNumCajas: (numCajas) => set(() => ({ numCajas })),
  setCajasEstiba: (cajasEstiba) => set(() => ({ cajasEstiba })),

  setStartProcess: (startProcess) => set(() => ({ startProcess })),
  setCloseProcess: (closeProcess) => set(() => ({ closeProcess })),
  setEndLoading: (endLoading) => set(() => ({ endLoading })),
  setContainerClose: (containerClose) => set(() => ({ containerClose })),
  setContainerOulet: (containerOulet) => set(() => ({ containerOulet })),

  setDataTruck: (ladata) => set(ladata),
  setPhoto1: async (photo1) => {
    const laPhoto = (await handleWatermark(
      photo1,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo1: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto2: async (photo2) => {
    const laPhoto = (await handleWatermark(
      photo2,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo2: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto3: async (photo3) => {
    const laPhoto = (await handleWatermark(
      photo3,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo3: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto4: async (photo4) => {
    const laPhoto = (await handleWatermark(
      photo4,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo4: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto5: async (photo5) => {
    const laPhoto = (await handleWatermark(
      photo5,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo5: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto6: async (photo6) => {
    const laPhoto = (await handleWatermark(
      photo6,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo6: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto7: async (photo7) => {
    const laPhoto = (await handleWatermark(
      photo7,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo7: laPhoto! }));
    // get().getStatusT();
  },
  setPhoto8: async (photo8) => {
    const laPhoto = (await handleWatermark(
      photo8,
      get().producer,
      get().farm
    )) as any;
    set(() => ({ photo8: laPhoto! }));
    // get().getStatusT();
  },

  getDataTruck: () => {
    const obj = {
      clientId: get().clientId,
      container: get().container,
      producerId: get().producerId,
      farmId: get().farmId,
      brandId: get().brandId,
      boxId: get().boxId,
      magap: get().magap,
      ciConductor: get().ciConductor,
      placa: get().placa,
      calidad: get().calidad,
      calidadCi: get().calidadCi,
      gancho: get().gancho,
      ganchoCi: get().ganchoCi,
      driver: get().driver,
      companyTransport: get().companyTransport,
      observation: get().observation,
      numCajas: get().numCajas,
      cajasEstiba: get().cajasEstiba,
      balerCode: get().balerCode,

      photo1: get().photo1,
      photo2: get().photo2,
      photo3: get().photo3,
      photo4: get().photo4,
      photo5: get().photo5,
      photo6: get().photo6,
      photo7: get().photo7,
      photo8: get().photo8,

      startProcess: get().startProcess,
      closeProcess: get().closeProcess,
      endLoading: get().endLoading,
      containerClose: get().containerClose,
      containerOulet: get().containerOulet,
    } as WorkflowTruckRequiredI;

    return obj;
  },

  getStatusT: () =>
    set(() => {
      const obj = get().getDataTruck();
      const values = Object.values(obj);
      let num = 0;
      for (const x of values) {
        if (x) num++;
      }
      const percentage = (num * 100) / 25;

      return {
        statusT: percentage,
      };
    }),

  resetClient: () => {
    set(() => ({
      producerId: null,
      producer: "",
      farmId: null,
      farm: "",
      brandId: null,
      brand: "",
      boxId: null,
      box: "",
      balerCode: "",
      zone: "",
      producerShort: "",
      farmShort: "",
    }));
  },
  resetProducer: () => {
    set(() => ({
      farmId: null,
      farm: "",
      balerCode: "",
      zone: "",
      producerShort: "",
      farmShort: "",
    }));
  },
  resetFarm: () => {
    set(() => ({
      farmId: null,
      farm: "",
      farmShort: "",
      balerCode: "",
      zone: "",
    }));
  },

  onClear: () => {
    set(() => ({
      step: "Formulario",

      id: null,
      container: "",
      client: "",
      clientId: null,
      producer: "",
      producerId: null,
      farm: "",
      farmId: null,
      producerShort: "",
      farmShort: "",
      magap: "",
      zone: "",
      balerCode: "",
      brand: "",
      brandId: null,
      box: "",
      boxId: null,
      ciConductor: "",
      placa: "",
      calidad: "",
      calidadCi: "",
      gancho: "",
      ganchoCi: "",
      driver: "",
      companyTransport: "",
      observation: "",
      numCajas: null,
      cajasEstiba: null,

      startProcess: "",
      closeProcess: "",
      endLoading: "",
      containerClose: "",
      containerOulet: "",

      statusT: 0,

      photo1: "",
      photo2: "",
      photo3: "",
      photo4: "",
      photo5: "",
      photo6: "",
      photo7: "",
      photo8: "",
    }));
  },
});
